<template>
  <nav v-if="!isSearchPage" class="Navigation">
    <div class="Inner">
      <NuxtLink class="NavigationItem" to="/guides">ご利用ガイド</NuxtLink>
      <NuxtLink class="NavigationItem" :to="conditionPageLink">カードの状態</NuxtLink>
      <NuxtLink class="NavigationItem" to="/help">お問合せ</NuxtLink>
    </div>
  </nav>
</template>

<script lang="ts" >
import { useRouter } from '#imports'
import { defineNuxtComponent } from '#app'
import { computed } from 'vue'
import type { Genre } from '@/types/genre'

export default defineNuxtComponent({
  props: {
    genre: {
      type: String as () => Genre,
      default: 'pokemon'
    }
  },
  setup(props) {
    const router = useRouter()
    const conditionPageLink = computed(() => `/${props.genre}/conditions`)
    const isSearchPage = computed(() => router.currentRoute.value.path === '/pokemon/search')

    return {
      conditionPageLink,
      isSearchPage,
    }
  }
})
</script>

<style scoped>
.Navigation {
  width: 100%;
  display: flex;
  padding: 4px 16px;
}

.Inner {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 160%;
  letter-spacing: 0.11px;
}

.NavigationItem {
  flex: 1;
  text-align: center;
  border-right: 1px solid #CCC;
  padding: 4px 0;
}

.NavigationItem:last-of-type {
  border-right: none;
}
</style>
